import { render, staticRenderFns } from "./PdfDownloadButton.vue?vue&type=template&id=807e0f8a&scoped=true"
import script from "./PdfDownloadButton.vue?vue&type=script&lang=js"
export * from "./PdfDownloadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807e0f8a",
  null
  
)

export default component.exports